/* eslint-disable sort-keys */
import React from 'react'

import { StepItemComponent } from '../../components'
import SectionLayout from '../../layouts/SectionLayout/SectionLayout'
import { ContentParser, hasNulls } from '../../utils/helpers'
import { contentCardsStyling } from './BlogTips.module.css'

const BlogTips = ({ slice }) => {
  const { blogtipsheading } = slice

  const contentCards = ContentParser(slice, 'contentcard').filter(
    (res) => !hasNulls(Object.values(res)),
  )

  return (
    <SectionLayout heading={blogtipsheading} withHeader>
      <div className={contentCardsStyling}>
        {contentCards.length > 0 &&
          contentCards.map((card, index) => {
            return (
              <StepItemComponent
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                step={{
                  title: card.contentcardtitle,
                  content: card.contentcardcontent,
                }}
                vacanciesStep
              />
            )
          })}
      </div>
    </SectionLayout>
  )
}

export default BlogTips
